import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import apiClient from "../api/apiClient";
import { useCart } from "./CartContext";

const NaveBar = () => {
  const { cart, removeFromCart, updateQuantity, getCartCount } = useCart();
  const [categories, setCategories] = useState([]);
  const [isCartOpen, setIsCartOpen] = useState(false); // Changé à false par défaut

  // Récupérer les catégories depuis l'API avec apiClient
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await apiClient.get(`/categories`);
        setCategories(response.data);
      } catch (error) {}
    };

    fetchCategories();
  }, []);

  // Fonction pour ouvrir le panier
  const openCart = () => {
    console.log("openCart appelé, état actuel:", isCartOpen);
    setIsCartOpen(true);
  };

  // Fonction pour fermer le panier
  const closeCart = () => {
    setIsCartOpen(false);
  };

  // Fonction pour basculer l'état du panier
  const toggleCart = () => {
    setIsCartOpen(!isCartOpen);
  };

  return (
    <div>
      <div
        className={`offcanvas__overlay ${isCartOpen ? "open" : ""}`}
        onClick={closeCart}
      ></div>
      <div className={`sidemenu-wrapper-cart ${isCartOpen ? "open" : ""}`}>
        <div className="sidemenu-content">
          <div className="widget widget-shopping-cart">
            <h4>Mon panier</h4>
            <div className="sidemenu-cart-close" onClick={closeCart}>
              <i className="far fa-times"></i>
            </div>
            <div className="widget-shopping-cart-content">
              <ul className="pesco-mini-cart-list">
                {cart.map((item) => (
                  <li key={item.id_prod} className="sidebar-cart-item">
                    <a
                      href="#"
                      className="remove-cart"
                      onClick={(e) => {
                        e.preventDefault();
                        removeFromCart(item.id_prod);
                      }}
                    >
                      <i className="far fa-trash-alt"></i>
                    </a>
                    <div className="cart-item-content">
                      <img
                        src={
                          item.images && item.images[0]
                            ? `${process.env.REACT_APP_API_URL}/${item.images[0]}`
                            : "assets/images/products/cart-1.jpg"
                        }
                        alt={item.nom_prod}
                        onError={(e) => {
                          e.target.src = "assets/images/products/cart-1.jpg";
                        }}
                      />
                      <div className="item-details">
                        <span className="product-name">{item.nom_prod}</span>
                        <div className="quantity-controls">
                          <button
                            onClick={() =>
                              updateQuantity(item.id_prod, item.quantity - 1)
                            }
                          >
                            -
                          </button>
                          <span>{item.quantity}</span>
                          <button
                            onClick={() =>
                              updateQuantity(item.id_prod, item.quantity + 1)
                            }
                          >
                            +
                          </button>
                        </div>
                      </div>
                    </div>
                  </li>
                ))}
              </ul>

              {cart.length > 0 ? (
                <div className="cart-footer">
                  <div className="cart-button-box">
                    <Link
                      to="/checkout"
                      className="theme-btn style-one"
                      onClick={closeCart} // Ferme le panier lors du clic sur "Envoyer une demande"
                    >
                      Envoyer une demande
                    </Link>
                  </div>
                </div>
              ) : (
                <div className="empty-cart-message">
                  <p>Votre panier est vide</p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      <header className="header-area">
        <div className="search-header-main">
          <div className="container">
            <div className="search-header-inner">
              <div className="site-branding">
                <Link to="/" className="brand-logo">
                  <img src="assets/images/logo/logo-main.png" alt="Logo" />
                </Link>
              </div>

              <div className="hotline-support item-rtl">
                <div className="icon">
                  <i className="flaticon-support"></i>
                </div>
                <div className="info">
                  <span>24/7 Support</span>
                  <h5>
                    <Link to="tel:+224627020871">627020871</Link>
                  </h5>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="header-navigation style-one">
          <div className="container">
            <div className="primary-menu">
              <div className="site-branding d-lg-none d-block">
                <Link to="/" className="brand-logo">
                  <img src="assets/images/logo/logo-mobile.png" alt="Logo" />
                </Link>
              </div>

              <div className="nav-inner-menu">
                <div className="main-categories-wrap d-none d-lg-block"></div>

                <div className="pesco-nav-main">
                  <div className="pesco-nav-menu">
                    <div className="pesco-tabs style-three d-block d-lg-none">
                      <ul className="nav nav-tabs mb-30" role="tablist">
                        <li>
                          <button
                            className="nav-link active"
                            data-bs-toggle="tab"
                            data-bs-target="#nav1"
                            role="tab"
                          >
                            Menu
                          </button>
                        </li>
                      </ul>
                      <div className="tab-content">
                        <div className="tab-pane fade show active" id="nav1">
                          <nav className="main-menu">
                            <ul>
                              <li>
                                <Link to="/">Accueil</Link>
                              </li>
                              <li>
                                <Link to="/produits">Produits</Link>
                              </li>
                              <li>
                                <Link to="/achat-externalise">
                                  Achat Externalise
                                </Link>
                              </li>
                            </ul>
                          </nav>
                        </div>
                      </div>
                    </div>

                    <div className="hotline-support d-flex d-lg-none mt-30">
                      <div className="icon">
                        <i className="flaticon-support"></i>
                      </div>
                      <div className="info">
                        <span>24/7 Support</span>
                        <h5>
                          <a href="tel:+224627020871">+224 627 02 08 71</a>
                        </h5>
                      </div>
                    </div>
                    <nav className="main-menu d-none d-lg-block">
                      <ul>
                        <li>
                          <Link to="/">Accueil</Link>
                        </li>
                        <li>
                          <Link to="/produits">Produits</Link>
                        </li>
                        <li>
                          <Link to="/achat-externalise">Achat Externalise</Link>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
              <div className="nav-right-item style-one">
                <ul>
                  <li>
                    <button
                      className="cart-button d-flex align-items-center"
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        console.log("Clic sur panier détecté");
                        openCart();
                      }}
                      style={{
                        cursor: "pointer",
                        border: "none",
                        background: "transparent",
                      }}
                    >
                      <div className="icon">
                        <i className="fas fa-shopping-bag"></i>
                        <span className="pro-count">{getCartCount()}</span>
                      </div>
                    </button>
                  </li>
                </ul>
                <div className="navbar-toggler d-block d-lg-none">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default NaveBar;
